import Analytics from '@getaccept/lib-shared/src/analytics';
import { LocalStorageKey } from '@getaccept/lib-shared/src/enums/local-storage';
import * as LocalStorageHelper from '@getaccept/lib-shared/src/helpers/local-storage.helper';
import { AnalyticsEvent, AnalyticsUserTrait } from '@getaccept/lib-shared/src/types/analytics';
import type { ErrorMessage } from '../../common/types/error-message';
import { SignupErrorKey } from '../../common/enums/signup-error-key';
import type { ProfileInformation } from '../types/profile-information';
import { t } from '../../common/helpers/translation';
import { useGoogleTagManager } from '../../common/composables/google-tag-manager.composable';

export function getErrorMessage(error: Error) {
  return {
    title: t('something-went-wrong'),
    description:
      error.message === SignupErrorKey.InvalidId
        ? t('please-verify-that-your-link-is-valid')
        : t('please-try-again-or-contact-support_v2'),
  };
}

export function trackUserInfo(profileInformation: ProfileInformation, id: string) {
  const analyticsData = {
    [AnalyticsUserTrait.FirstName]: profileInformation.firstName,
    [AnalyticsUserTrait.LastName]: profileInformation.lastName,
    [AnalyticsUserTrait.Language]: profileInformation.language,
    [AnalyticsUserTrait.Mobile]: profileInformation.phoneNumber,
  };
  Analytics.identify(id ?? undefined, analyticsData);

  const localData = LocalStorageHelper.getLocalStorage(LocalStorageKey.SignupAnalyticsData);
  const data = localData ? JSON.parse(localData) : {};

  LocalStorageHelper.setLocalStorage(
    LocalStorageKey.SignupAnalyticsData,
    JSON.stringify({ ...data, ...analyticsData })
  );
}

export function trackPageLoaded(id: string, isInvitation: boolean) {
  const data = LocalStorageHelper.getLocalStorage(LocalStorageKey.SignupAnalyticsData);
  const localData = data ? JSON.parse(data) : {};
  Analytics.identify(id ?? undefined, { ...localData, [AnalyticsUserTrait.SignupStep]: 2 });
  Analytics.track(AnalyticsEvent.SignupLoadedStep2, { [AnalyticsUserTrait.SignupStep]: 2 });
  useGoogleTagManager().verifyEmail(id, isInvitation);
}

export function trackVerifyUserError(errorMessage: ErrorMessage) {
  Analytics.track(AnalyticsEvent.SignupFailed, {
    [AnalyticsUserTrait.SignupStep]: 2,
    errorMessage: errorMessage.title,
  });
  Analytics.identify(undefined, {
    [AnalyticsUserTrait.SignupStep]: 2,
  });
}
